import {
  SET_LAST_INSIGHT_PAGE,
  SET_LAST_AUDIENCE_BUILDER_PAGE,
  SET_LAST_CAMPAIGN_SUMMARY_PAGE
} from '../constants';


export const setLastInsightPage = data => ({
  type: SET_LAST_INSIGHT_PAGE,
  data,
});
export const setLastAudienceBuilderPage = data => ({
  type: SET_LAST_AUDIENCE_BUILDER_PAGE,
  data,
});
export const setLastCampaignSummaryPage = data => ({
  type: SET_LAST_CAMPAIGN_SUMMARY_PAGE,
  data,
});


